import { Paper, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";

export default function PerformanceSkel() {
  return (
    <Stack spacing={2.5}>
      <Grid container spacing={1.25}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid size={6} key={index}>
            <Paper variant="outlined" sx={{ p: 1.75 }}>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="70%" height={32} />
              <Skeleton variant="text" width="90%" />
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Skeleton variant="rounded" height={250} />
      <Skeleton variant="rounded" height={250} />
      <Skeleton variant="rounded" height={40} />
      <Skeleton variant="rounded" height={320} />
    </Stack>
  );
}
